import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'

interface NavItemProps {
	label: string
	href: string
	className?: string
}

export function NavItem({ label, href, className }: NavItemProps) {
	const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		// Check if the href is an anchor link
		if (href.startsWith('#')) {
			e.preventDefault()
			const targetId = href.substring(1)
			const targetElement = document.getElementById(targetId)

			if (targetElement) {
				targetElement.scrollIntoView({ behavior: 'smooth' })
			}
		}
	}

	return (
		<Link
			to={href}
			onClick={handleClick}
			className={cn(
				'flex cursor-pointer items-center text-sm font-semibold',
				className
			)}>
			{label}
		</Link>
	)
}
